import { useEffect } from 'react'

const SITE = 'https://drontalia.es';

function setMeta(selector, attr, value) {
    const el = document.head.querySelector(selector);
    if (el) el.setAttribute(attr, value);
}

// Actualiza título, descripción, canonical y Open Graph de cada ruta
function Seo({ title, description, path }) {
    useEffect(() => {
        const url = SITE + path;
        document.title = title;
        setMeta('meta[name="description"]', 'content', description);
        setMeta('link[rel="canonical"]', 'href', url);
        setMeta('meta[property="og:title"]', 'content', title);
        setMeta('meta[property="og:description"]', 'content', description);
        setMeta('meta[property="og:url"]', 'content', url);
        setMeta('meta[name="twitter:title"]', 'content', title);
        setMeta('meta[name="twitter:description"]', 'content', description);
    }, [title, description, path]);

    return null;
}

export default Seo
